import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Settings } from './settings';
import { DAO } from '../modal/DAO';
import { Auth0UserService } from './auth0UserService.service';
import { AppConfig } from '../app.config';
/**
 * This guard is an example of how you would provide a `AuthConfig` to the `AuthenticationService`.
 * This is just one way, not the only way. Note that as of now (v1.0.0) if you call login multiple times for different configs
 * unexpected things may happen. I have a hunch that it has to do with SalteAuth's use of SessionStorage and Cookies, but I'm not positive.
 * For now, avoid letting users switch `AuthConfig`s
 */
@Injectable({
    providedIn: 'root',
})
export class AuthGuard  {
    constructor(
        public appConfig: AppConfig, 
        private setting: Settings,
        private router: Router,
        private dao:DAO,
        private auth0UserService: Auth0UserService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        
        if(!!this.dao.auth0User1?.sessionIsGood && !!this.dao.auth0User1.agencyCode && this.dao.auth0User1.agencyCode.length >= 5)
        {
            return true;
        }
        setTimeout(() => this.router.navigate([""]));
        return false;
    }
}
